import {IntermediatePart} from "../../intermediatePart";

export default class CeilingLights extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'ceiling_lights';
    this.partName = 'Ceiling Lights';
  }

  load(dbFeature) {
    return super.load_(dbFeature, new CeilingLights());
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Globals.CeilingLights;
    }
  }
}